var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBurger = function SvgMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.87 3h18.26s.87 0 .87.947v.948s0 .947-.87.947H2.87s-.87 0-.87-.947v-.948S2 3 2.87 3M2.87 10.579h18.26s.87 0 .87.947v.948s0 .947-.87.947H2.87s-.87 0-.87-.947v-.948s0-.947.87-.947M2.87 18.158h18.26s.87 0 .87.947v.948s0 .947-.87.947H2.87S2 21 2 20.053v-.948s0-.947.87-.947"
  })));
};
export default SvgMenuBurger;